// extracted by mini-css-extract-plugin
module.exports = {"root":"Wrapper_root_eV80K"};